import {profSpac} from 'constants/url';
import useAdd from '../../../components/hooks/useAdd';
import {AddingOptions} from '../../../components/grid-dx/types';

function useAddProfSpac() {
  const addProfSpac = useAdd(profSpac);
  return (addingOptions: AddingOptions) => addProfSpac(addingOptions);
}

export default useAddProfSpac;
